var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { overflow: "auto" } }, [
    _c("div", { staticClass: "nav-bar-container" }, [
      _c("div", { staticClass: "nav-bar clearfix" }, [
        _c("div", { staticClass: "summary-items" }, [
          _vm.showTendersTable
            ? _c(
                "div",
                {
                  staticClass: "summary-item",
                  on: {
                    click: function ($event) {
                      return _vm.scrollMeTo("tenderBids")
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "summary-badge summary-badge__dark" },
                    [_vm._v(_vm._s(_vm.tenderBids.length))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-item__title" }, [
                    _vm._v(_vm._s(_vm.$t("dashboard.tendersInProgress"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showProjectsTable
            ? _c(
                "div",
                {
                  staticClass: "summary-item",
                  on: {
                    click: function ($event) {
                      return _vm.scrollMeTo("vendorProjects")
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "summary-badge summary-badge__normal" },
                    [_vm._v(_vm._s(_vm.vendorProjects.length))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-item__title" }, [
                    _vm._v(_vm._s(_vm.$t("dashboard.activeProjects"))),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTendersTable,
            expression: "showTendersTable",
          },
        ],
        ref: "tenderBids",
      },
      [
        _c("TendersBidTable", {
          attrs: {
            vendorId: _vm.vendorId,
            model: _vm.tenderBids,
            isVendorAccount: _vm.isVendorAccount,
            isTenderRep: _vm.isTenderRep,
          },
          on: {
            "update:vendorId": function ($event) {
              _vm.vendorId = $event
            },
            "update:vendor-id": function ($event) {
              _vm.vendorId = $event
            },
            "update:model": function ($event) {
              _vm.tenderBids = $event
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.enableProjectFeature
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showProjectsTable,
                expression: "showProjectsTable",
              },
            ],
            ref: "vendorProjects",
          },
          [
            _c("VendorProjectsTable", {
              attrs: { heading: "Projects", model: _vm.vendorProjects },
              on: {
                "update:model": function ($event) {
                  _vm.vendorProjects = $event
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "work-permit-container" },
      [_vm.enableWorkPermitsFeature ? _c("WorkPermits") : _vm._e()],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }